"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FromLong_1 = require("./FromLong");
var BroadcastAddress_1 = require("./BroadcastAddress");
var ToLong_1 = require("./ToLong");
function lastHost(subnet) {
    var broadcastLong = BroadcastAddress_1.broadcastAddress(subnet);
    return FromLong_1.fromLong(ToLong_1.toLong(broadcastLong) - 1);
}
exports.lastHost = lastHost;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTGFzdEhvc3QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJMYXN0SG9zdC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLHVDQUFxQztBQUNyQyx1REFBcUQ7QUFDckQsbUNBQWlDO0FBRWpDLGtCQUEwQixNQUFjO0lBQ3RDLElBQUksYUFBYSxHQUFHLG1DQUFnQixDQUFDLE1BQU0sQ0FBQyxDQUFBO0lBQzVDLE1BQU0sQ0FBQyxtQkFBUSxDQUFDLGVBQU0sQ0FBQyxhQUFhLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQTtBQUM1QyxDQUFDO0FBSEQsNEJBR0MifQ==


//////////////////
// WEBPACK FOOTER
// ./src/LastHost.ts
// module id = 10
// module chunks = 0